import BaseAPI from '@/apis/base/baseApi';
import httpClient from '@/apis/base/httpclient';

class MISPAPI extends BaseAPI {
	constructor() {
		super();
	}
	apiName = 'Business';
	controllerName = 'misp';
	getDetailEventAsync(event_uuid) {
		let request = {
			url: [this.getAPIUrl(), 'detail', event_uuid].join('/')
		};
		return httpClient.getAsync(request);
	}
	getDetailIocAsync(attribute_uuid) {
		let request = {
			url: [this.getAPIUrl(), 'detail_ioc', attribute_uuid].join('/')
		};
		return httpClient.getAsync(request);
	}
	
}

export default new MISPAPI();